// extracted by mini-css-extract-plugin
export var acceptButton = "_16-5";
export var fullContent = "_16-4";
export var link = "_16-6";
export var linkIcon = "_16-7";
export var sideContent = "_16-3";
export var sideImage = "_16-2";
export var sideImageWrapper = "_16-1";
export var splitLayout = "_16-0";